import {ChangeDetectorRef,Component, Inject, OnInit} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import Swiper from 'swiper/bundle';

@Component({
  selector: 'app-photo-dialog',
  templateUrl: './photo-dialog.component.html',
  styleUrls: ['./photo-dialog.component.scss']
})
export class PhotoDialogComponent implements OnInit {

  project: any;

  activeIndex: number = 1;

  SERVER_URL = environment.SERVER_URL;

  constructor(
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.project = this.data.project;
  }

  cancel() {
    this.dialogRef.close();
  }

  onActiveIndexChange(swiper: Swiper) {
    this.activeIndex = swiper.activeIndex + 1;
    this.cdr.detectChanges();

  }
}
